import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, requiredPerm, requireAdmin = false }) {
  const { isAuthenticated, isLoading, hasPerm, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && !user?.isAdmin) {
    return <ForbiddenView message="Admin permission required" />;
  }

  if (requiredPerm && !hasPerm(requiredPerm)) {
    return <ForbiddenView message={`You don't have access to this page.`} />;
  }

  return children;
}

function ForbiddenView({ message }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">403</h1>
      <p className="text-gray-600 mb-6">{message}</p>
      <a href="/" className="text-blue-600 hover:underline">
        Back to home
      </a>
    </div>
  );
}
